import type { AppDirectClient } from '../client.js';
import { authBffDebug } from '../debug.js';
import { buildSessionCookies } from '../session/cookies.js';
import type { ImportSessionResult, ResolvedConfig } from '../types.js';
import { assertConfiguredApplicationAssignment } from './entitlement.js';

export async function importSession(
  config: ResolvedConfig,
  client: AppDirectClient,
  input: { sessionToken: string; refreshToken: string },
): Promise<ImportSessionResult> {
  if (config.applicationId == null) {
    authBffDebug('import-session', 'entitlement check skipped', { applicationId: null });
  } else {
    authBffDebug('import-session', 'running entitlement check', {
      applicationId: config.applicationId,
    });
    await assertConfiguredApplicationAssignment(config, client, input.sessionToken);
    authBffDebug('import-session', 'entitlement check passed', {
      applicationId: config.applicationId,
    });
  }

  return {
    cookiesToSet: buildSessionCookies(config, input.sessionToken, input.refreshToken),
  };
}
